import * as React from 'react';
import { motion } from 'motion/react';
import { MediaQuery, SliderCarousel } from '@grandvisionhq/common';
import { Container, Heading } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/lib-visuals';
import 'classnames';
import '@grandvisionhq/analytics';
import '@grandvisionhq/carts-v2';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-utils-react';
import '../ProductBlock/types.js';
import '../ProductBlock/utils/get-variant-images.js';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/api-client';
import { RecommendationsGalleryPageSection } from './components/restructured/RecommendationsGalleryPageSection/RecommendationsGalleryPageSection.js';
import { BannerRecommendationContainer } from './components/BannerRecommendationContainer.js';
import { ListItemWrapper } from './components/ListItemWrapper.js';
import { ProductRecommendationContainer } from './components/ProductRecommendationContainer.js';
import { isProductRecommendation } from './utils/guards.js';
import { isValidRecommendation } from './utils/is-valid-recommendation.js';

const RecommendationListPage = ({ labels , recommendations , className  })=>{
    const { isRestructuredProductBlockEnabled  } = useFeatureToggles();
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const isPhone = MediaQuery.useIsPhone();
    const validRecommendations = recommendations.filter(isValidRecommendation);
    const renderRecommendation = (withListItem = false)=>(recommendation, index)=>{
            const isProductRec = isProductRecommendation(recommendation);
            const Wrapper = withListItem ? ListItemWrapper : React.Fragment;
            return /*#__PURE__*/ React.createElement(Wrapper, {
                key: isProductRec ? recommendation.sku : `${recommendation.position}-${recommendation.title}`
            }, isProductRec ? /*#__PURE__*/ React.createElement(ProductRecommendationContainer, {
                recommendation: recommendation,
                position: index + 1
            }) : /*#__PURE__*/ React.createElement(BannerRecommendationContainer, {
                recommendation: recommendation
            }));
        }
    ;
    if (!validRecommendations.length) return null;
    if (isRestructuredProductBlockEnabled) {
        return /*#__PURE__*/ React.createElement(RecommendationsGalleryPageSection, {
            title: labels.title,
            recommendations: recommendations
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "recommendation-list-page-layout--background"
    }, /*#__PURE__*/ React.createElement(Container, null, isBigScreen ? /*#__PURE__*/ React.createElement(motion.div, {
        style: {
            overflow: 'hidden'
        },
        variants: {
            start: {
                height: 0
            },
            end: {
                height: 'auto'
            }
        },
        transition: {
            type: 'tween'
        },
        initial: "start",
        animate: "end",
        className: `recommendation-list ${className}`
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        className: "recommendation-list__title"
    }, labels.title), /*#__PURE__*/ React.createElement(motion.ul, {
        variants: {
            start: {
                opacity: 1
            },
            end: {
                opacity: 1
            }
        },
        transition: {
            delayChildren: 0.25,
            staggerChildren: 0.1
        },
        className: "recommendation-list__list"
    }, validRecommendations.map(renderRecommendation(true)))) : /*#__PURE__*/ React.createElement("div", {
        className: `recommendation-list ${className}`
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        className: "recommendation-list__title"
    }, labels.title), /*#__PURE__*/ React.createElement(SliderCarousel, {
        itemWidth: isPhone ? 186 : 246
    }, validRecommendations.map(renderRecommendation())))));
};

export { RecommendationListPage };
//# sourceMappingURL=RecommendationListPage.js.map
